import React, { memo } from 'react';
import { CheckCircle2 } from 'lucide-react';
export function MethodSection() {
  const items = [{
    title: 'Contexto productivo primero.',
    desc: 'El técnico no memoriza definiciones. El técnico resuelve problemas reales. Cada módulo parte de una situación concreta de granja antes de desarrollar el concepto.'
  }, {
    title: 'Especies y sistemas reales.',
    desc: 'Trucha en zonas frías, tilapia en el trópico, camarón en la costa, cachama en ríos cálidos. El material que tus alumnos reconocen porque es lo que van a manejar en el campo.'
  }, {
    title: 'Del aula al campo en cada sesión.',
    desc: 'Cada módulo incluye actividades aplicables al laboratorio, a la visita de campo o al aula con simulación. Ninguna clase termina solo con teoría.'
  }];
  return <section className="py-8 px-4 bg-brand-navy text-white" data-id="element-112">
      <div className="max-w-4xl mx-auto text-center" data-id="element-113">
        <p className="text-brand-yellow font-display font-bold uppercase text-sm tracking-widest mb-2" data-id="element-114">
          ✨ El Método
        </p>
        <h2 className="text-3xl md:text-5xl font-display font-bold uppercase leading-tight mb-3" data-id="element-115">
          "Técnico <span className="text-brand-yellow" data-id="element-116">Aplicado</span>"
        </h2>
        <p className="text-base md:text-lg text-white/90 font-medium max-w-2xl mx-auto mb-6 leading-snug" data-id="element-117">
          Cada tomo construye competencias sobre competencias — como se aprende
          a producir en el mundo real, pero traducido al aula de formación
          técnica.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-118">
          {items.map((it, i) => <div key={i} className="bg-white text-brand-ink rounded-lg p-4 border-b-4 border-brand-yellow text-left" data-id="element-119">
              <CheckCircle2 className="w-6 h-6 text-brand-cta mb-2" data-id="element-120" />
              <h3 className="font-display text-lg md:text-xl text-brand-navy uppercase font-bold mb-1 leading-tight" data-id="element-121">
                {it.title}
              </h3>
              <p className="text-sm text-brand-mute leading-snug font-medium" data-id="element-122">
                {it.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}